import { render } from "./AdditionalFormComponent.vue?vue&type=template&id=7cabd25a&scoped=true"
import script from "./AdditionalFormComponent.vue?vue&type=script&lang=js"
export * from "./AdditionalFormComponent.vue?vue&type=script&lang=js"

import "./AdditionalFormComponent.vue?vue&type=style&index=0&id=7cabd25a&scoped=true&lang=css"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cabd25a"]])

export default __exports__